<template>
  <div class="header-wrap">
    <div class="header clearfix">
      <div class="logo-wrap pull-left">
        <router-link to="/" class="logo-link"></router-link>
        <img src="images/logo.png" alt="" class="logo">
        <h1 class="brand">槃灵科技</h1>
      </div>
      <!-- <div class="nav-wrap pull-right">
        <router-link :to="item.href" v-for="(item, index) in navList" :key="index"  v-bind:class="navIndex==index ? 'active' : ''" class="nav-item" @click.native="navTab(index)">{{item.title}}</router-link>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      navList: [
        {
          href: '/',
          title: '首页'
        },
        {
          href: '/link',
          title: '技术导航'
        },
      ],
      navIndex: '0'
    }
  },
  mounted () {
    let index = sessionStorage.getItem('navIndex');
    if (index) {
      this.navIndex = index
    } else {
      this.navIndex = 0
    }

  },
  watch: {
    $route(to) {
      if (to.path.indexOf('/link') != -1) {
        this.navIndex = 1;
        sessionStorage.setItem('navIndex', 1);
      } else  {
        this.navIndex = 0
        sessionStorage.setItem('navIndex', 0);
      }
    }
  },
  methods: {
    navTab (index) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index);
    }
  }
}
</script>

<style lang="scss" scoped>
  html, body {
    width: 100%;
  }
  .header-wrap {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
  }

  .header {
    width: 1200px;
    height: 80px;
    margin: auto;
    line-height: 80px;
  }
  .logo-wrap {
    display: inline-block;
    position: relative;
    width: 200px;
    .logo-link {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .logo {
      width: 48px;
      height: 48px; 
      margin-right: 8px;
      vertical-align: middle; 
    }
    .brand {
      display: inline-block;
      vertical-align: middle;
      font-size: 28px;
      font-weight: 600;
    }
  }

  .nav-wrap {
    display: inline-block;
    .nav-item {
      position: relative;
      margin-left: 60px;
      font-size: 16px;
      &:hover {
        color: #ec1c24;
        &::after {
          content: "";
          position: absolute;
          bottom: -8px;
          left: 0;
          right: 0;
          margin: auto;
          width: 20px;
          height: 2px;
          background-color: #ec1c24;
        }
      }
    }

    .nav-item.active {
      color: #ec1c24;
      &::after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 0;
        right: 0;
        margin: auto;
        width: 20px;
        height: 2px;
        background-color: #ec1c24;
      }
    }
  }
</style>

